import { createContext } from "react";

const ProduceTypeContext = createContext();

export default ProduceTypeContext;